import styled from 'styled-components';

export const NftRoot = styled('div')`
  min-height: 448px;
  text-align: center;
  h3 {
    font-size: 26px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 5px;
  }
  p {
    font-size: 19px;
  }
  button {
    max-width: 100%;
  }
`;
export const NftImg = styled('img')`
  max-width: 100%;
`;
export const MultiplierBox = styled('p')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  margin: 0;
`;
export const ButtonGroup = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
`;
